<template>
    <div class="pt-2 px-4">
        <div v-if="reservation.event.eventRoutes.length > 0" class="bg-lightest radius-normal border-light my-4 py-3 px-3 d-flex flex-column">

            <route-form :routes="getAllRoutes" :reservation="reservation" title="Pick up location" :type="1"></route-form>

        </div>

        <div v-else class="bg-lightest radius-normal border-light d-flex my-4 px-3">
            <div class="text-center dark fs-largest pt-5 text-center mb-4 w-100">
                This event has no transportation available
            </div>
        </div>

    </div>
</template>

<script>
import RouteForm from './AddTransport/RouteForm'

import {mapGetters} from 'vuex'

export default {
    data: function() {
        return {
            routes: [],
            roundTrip: false
        }
    },
    props: {
        reservation: {
            type: Object
        }
    },
    created: function() {
    },
    computed: {
        ...mapGetters([
            'account',
            'getAllRoutes'
        ])
    },
    methods: {
        hasTransportChanged: function(e) {
            if(e.value == false){
                this.reservation.transport.transfers = [];
                this.createNumberOfTransfers();
            }
        }
    },
    components: {
        RouteForm
    }
}

//object sent to API
// transport: {
//     "transfers": [
//         {
//             "order": 0,
//             "date": "2017-12-05 00:00:00",
//             "transportDirection": 1,
//             "isCustom": false,
//             "route": {
//                 "id": 1,
//                 "name": "Rota Alfamar - Pickpup"
//             },
//             "stop": {
//                 "id": 3,
//                 "description": "Açoteias (Bus Stop Pinheiro)"
//             },
//             "exitStop": {
//                 "id": 25,
//                 "name": "Marina de Albufeira"
//             },
//             "schedule": {
//                 "id": 3,
//                 "lap": 1,
//                 "time": "07:55:00",
//                 "date": null,
//                 "timeShort": "07:55"
//             }
//         },
//         {
//             "order": 0,
//             "date": "2017-12-05 00:00:00",
//             "isCustom": false,
//             "route": {
//                 "id": 4,
//                 "name": "Rota Oceano - Dropoff"
//             },
//             "transportDirection": 2,
//             "stop": {
//                 "id": 25,
//                 "name": "Marina de Albufeira"
//             },
//             "exitStop": {
//                 "id": 25,
//                 "description": "Marina de Albufeira"
//             },
//             "schedule": {
//                 "id": 165,
//                 "lap": 1,
//                 "time": "14:00:00",
//                 "date": null,
//                 "timeShort": "14:00"
//             }
//         }
//     ]
// }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// AddTransport.vue?b7856194